'use client';

import { getZendeskAritle } from '@/api/public';
import logger from '@/utils/client-logger';
import { useCallback, useState } from 'react';

// FAQ搜索结果接口
interface SearchResult {
  id: string;
  title: string;
  link: string;
}

// Zendesk搜索API响应类型
interface ZendeskSearchResponse {
  results?: Array<{
    id: number;
    title: string;
    html_url: string;
  }>;
}

export function useContactAPI() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 搜索FAQ文章 - 使用fetch直接调用
  const searchFAQArticles = useCallback(async (query: string): Promise<SearchResult[]> => {
    if (!query.trim()) {
      return [];
    }

    setLoading(true);
    setError(null);

    try {
      // 直接使用fetch调用API
      const response: any = await getZendeskAritle({
        query,
        per_page: 9999,
        page: 1,
      });

      if (response.code === 200 && response.data) {
        const searchData = response.data as ZendeskSearchResponse;
        return (
          searchData.results?.map((item) => ({
            id: item.id?.toString() || Math.random().toString(),
            title: item.title || '',
            link: item.html_url || '',
          })) || []
        );
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'Search failed';
      setError(errorMsg);
      logger.error('FAQ搜索失败:', err);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    searchFAQArticles,
    clearError: () => setError(null),
  };
}
